module.exports = __webpack_public_path__ + "static/p10_cencerro-19a2e7c55ca485fb43482309692d5acc.png";